import { render, staticRenderFns } from "./ImgGenerateAI.vue?vue&type=template&id=0bcefc24&scoped=true"
import script from "./ImgGenerateAI.vue?vue&type=script&lang=js"
export * from "./ImgGenerateAI.vue?vue&type=script&lang=js"
import style0 from "./ImgGenerateAI.vue?vue&type=style&index=0&id=0bcefc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcefc24",
  null
  
)

export default component.exports